import React, { useEffect, useState } from "react";
import tower from '../assets/images/tower.png';
import africaImage from '../assets/images/africa.svg';
import asiaImage from '../assets/images/asia.svg';
import caribbean from '../assets/images/caribbean.svg';
import europe from '../assets/images/europe.svg';
import MiddleEast from '../assets/images/MiddleEast.svg';
import NorthAmerica from '../assets/images/NorthAmerica.svg';
import Southlationamerica from '../assets/images/SouthLationAmerica.svg';
import Global from '../assets/images/Global.svg';

import { LuDatabase } from "react-icons/lu";
import { MdOutlineWatchLater, MdOutlineSpeed } from "react-icons/md";
import { HiOutlineGlobe } from "react-icons/hi";
import { IoPlayCircleOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { ImCross } from "react-icons/im";
import { GoDownload } from "react-icons/go";
import { saveAs } from 'file-saver';
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from 'react-toastify';
import PlanImage from '../assets/images/New_Jul_2025/PlanMap.svg'
import { sessionTimeoutManager } from '../utils/sessionTimeoutManager';

const Plan = () => {
  const [planDetails, setPlanDetails] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [lpacode, setLpaCode] = useState('');
  const [purchaseDetails, setPurchaseDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    const partnerCode = localStorage.getItem('partnerCode');
    const plan_id = localStorage.getItem('plan_id');

    fetch(`${apiUrl}Esim/Get_plan_details_byid?plan_id=${plan_id}&Partnercode=${partnerCode}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      if (response.status === 401 || response.status === 403) {
        // trigger global session timeout modal
        sessionTimeoutManager.showSessionTimeout();
        throw new Error('Session expired or access forbidden');
      }
      return response.json();
    })
    .then(data => {
      if (data.isSuccess) {
        setPlanDetails(data);
      } else {
        console.error('Failed to fetch plan details:', data.message);
      }
    })
    .catch(error => {
      console.error('Error fetching plan details:', error);
    });
  }, []);

  const handleAddBundle = () => {
    const partnerCode = localStorage.getItem('partnerCode');
    const planCode = localStorage.getItem('planCode');
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('No token found in localStorage');
      return;
    }

    setLoading(true);

    const requestData = {
      partnerCode: partnerCode,
      planCode: [planCode],
      travelDate: "",
      quantity_plan: 1
    };

    fetch(`${apiUrl}Esim/PurhaseSim_Bundle`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
    .then(response => {
      if (response.status === 401 || response.status === 403) {
        sessionTimeoutManager.showSessionTimeout();
        throw new Error('Session expired or access forbidden');
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('API response:', data);
      if (!data.isSuccess) {
        throw new Error(data.message);
      }

      const purchasePlan = data.purchaseplanlist && data.purchaseplanlist.length > 0 
        ? data.purchaseplanlist[0] 
        : null;

      if (purchasePlan) {
        setPurchaseDetails(purchasePlan);
      }

      setLpaCode(data.lpacode);
      setShowQRModal(true);

      setModalMessage('Plan purchased successfully!');
      setShowSuccessModal(true);

      setTimeout(() => {
        setShowSuccessModal(false);
      }, 1000);

      setTimeout(() => {
        setShowConfirmModal(false);
      }, 1000);
    })
    .catch(error => {
      console.error('There was a problem with the API request:', error);
      toast.error('Error: ' + error.message);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const handleDownload = (lpacode) => {
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${lpacode}&size=200x200`;
    saveAs(qrCodeUrl, `QR_${lpacode}.png`);
  };
  
  if (!planDetails) {
    return <div><LoadingSpinner /></div>;
  }
  
  const handleCross = () => {
    setShowQRModal(false);
  };

  const { sellingcost, sellingcost_airhub, discount, planlist } = planDetails;
  const { validity, dataallowance, plantype } = planlist[0];
  const addInfo = planlist[0].addinformation || '';

  // Safely extract packageHTML from addInfo
  const extractPackageHTML = (html) => {
    if (!html) return '';
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const ul = doc.querySelector('ul');
    
    if (!ul) return html;
    
    return ul.outerHTML;
  };

  const packageHTML = extractPackageHTML(addInfo);
console.log("Package HTML:", packageHTML);
const parseListItems = (ulHtml) => {
  if (!ulHtml) return [<li key="0">No package details available</li>];

  try {
    const cleanedHtml = ulHtml
      .replace(/.*?<ul[^>]*>/s, '')
      .replace(/<\/ul>.*/s, '');

    const items = cleanedHtml
      .split(/<\/li>/)
      .map(item => item.trim())
      .filter(item => item.length > 0);

    return items.map((item, index) => (
      <li key={index} className="m-2" dangerouslySetInnerHTML={{ __html: item }} />
    ));
  } catch (error) {
    console.error('Error parsing list items:', error);
    return [<li key="0">Error loading package details</li>];
  }
};


  const selectedRegionId = localStorage.getItem('region');
  let sidebarImage = tower;

  if (selectedRegionId === '12') {
    sidebarImage = africaImage;
  } else if (selectedRegionId === '170') {
    sidebarImage = asiaImage;
  } else if (selectedRegionId === '101') {
    sidebarImage = caribbean;
  } else if (selectedRegionId === '12') {
    sidebarImage = europe;
  } else if (selectedRegionId === '5') {
    sidebarImage = Global;
  } else if (selectedRegionId === '5') {
    sidebarImage = MiddleEast;
  } else if (selectedRegionId === '8') {
    sidebarImage = NorthAmerica;
  } else if (selectedRegionId === '1') {
    sidebarImage = Southlationamerica;
  }
  
  function SuccessModal({ message, onClose }) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg p-6 shadow-lg max-w-sm w-full relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 px-4 py-2 text-white rounded-lg hover:bg-[#20bfb2]"
          >
            <ImCross size={20} color="grey" />
          </button>
          <div className="flex flex-col items-center justify-center h-full">
            <p className="text-5xl font-bold">{message}</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{backgroundColor:'#FFFFFF'}} className="main-content flex h-screen overflow-hidden p-4">
      <div className="content flex-1 p-4 rounded-r-lg overflow-auto">
       <div className="
  flex 
  flex-row 
  sm:grid sm:grid-cols-2 
  lg:grid-cols-5 
  gap-4 mb-8 
  overflow-x-auto 
  flex-nowrap 
  snap-x 
  snap-mandatory
  scrollbar-hide
">
  <div className="flex flex-col items-center p-4 bg-[#D9EFEF] rounded-lg shadow-md min-w-[90vw] max-w-[90vw] sm:min-w-0 sm:max-w-full snap-center">
    <LuDatabase size={30} />
    <span>{dataallowance}</span>
  </div>
  <div className="flex flex-col items-center p-4 bg-[#D9EFEF] rounded-lg shadow-md min-w-[90vw] max-w-[90vw] sm:min-w-0 sm:max-w-full snap-center">
    <MdOutlineWatchLater size={30} />
    <span>{validity}</span>
  </div>
  <div className="flex flex-col items-center p-4 bg-[#D9EFEF] rounded-lg shadow-md min-w-[90vw] max-w-[90vw] sm:min-w-0 sm:max-w-full snap-center">
    <HiOutlineGlobe size={30} />
    <span>{plantype}</span>
  </div>
  <div className="flex flex-col items-center p-4 bg-[#D9EFEF] rounded-lg shadow-md min-w-[90vw] max-w-[90vw] sm:min-w-0 sm:max-w-full snap-center">
    <MdOutlineSpeed size={30} />
    <span>2G/3G/4G/5G Data</span>
  </div>
  <div className="flex flex-col items-center p-4 bg-[#D9EFEF] rounded-lg shadow-md min-w-[90vw] max-w-[90vw] sm:min-w-0 sm:max-w-full snap-center">
    <IoPlayCircleOutline size={30} />
    <span>Autostart Enabled</span>
  </div>
</div>


        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <h2 className="text-xl font-bold mb-4">Package Details</h2>
            <ul className="list-disc ml-5">
              {parseListItems(packageHTML)}
            </ul>
            <p className="mt-4">
              <b>Compatibility:</b> Supports Android and iOS devices<br />
              (refer to FAQ for compatible handsets).
            </p>
          </div>
      <div className="flex-1 flex justify-center hidden md:block">
            <img
              src={PlanImage}
              alt="Region Illustration"
              className="max-w-full max-h-full rounded-lg shadow-md"
            />
          </div>
        </div>

      <div className="flex justify-end items-center p-4 border-t mt-6">
  <button
    className="rounded-2xl bg-[#27635C] hover:bg-[#0d5c5c] text-white font-bold px-8 py-3 transition duration-200 ease-in disabled:opacity-50 disabled:cursor-not-allowed shadow-2xl"
    onClick={() => setShowConfirmModal(true)}
    disabled={loading}
  >
    {userRole === "Partner" ? 
      (loading ? "Processing Purchase..." : `Buy Now - $${parseFloat(sellingcost).toFixed(2)}`) : 
      (loading ? "Processing..." : "Buy")
    }
  </button>
</div>

        
        {showSuccessModal && (
          <SuccessModal
            message={modalMessage}
            onClose={() => setShowSuccessModal(false)}
          />
        )}

        
       
        {showQRModal && purchaseDetails && (
         <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
         <div className="bg-white p-8 rounded-md flex flex-row relative">
           {/* Left column */}
           <div className="flex flex-col items-start w-96">
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span className="font-bold">Order ID:</span>{' '}
               <span className="ml-4">{purchaseDetails.orderid || 'N/A'}</span>
             </div>
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span span className="font-bold">APN:</span>{' '}
               <span className="ml-4">{purchaseDetails.apn || 'N/A'}</span>

             </div>
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span className="font-bold"> ICCID/MSISDN:</span>{' '}
               <span className="ml-4">{purchaseDetails.iccid || 'N/A'}</span>
             </div>
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span className="font-bold">SIMPIN:</span>{' '}
               <span className="ml-4">{purchaseDetails.simpin || 'N/A'}</span>
             </div>
           
{/*              
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
               <span className="font-bold">Authentication code:</span>{' '}
               <span className="ml-4">{purchaseDetails.lpacode || 'N/A'}</span>
             </div> */}
            {/* Here i added a new code like  */}
             <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">
                  For iOS Devices:
                  <span className="font-normal">
                    {" "}
                    Use Below SMDP & Activation code
                  </span>
                </h1>

                {(() => {
                  const fullCode = purchaseDetails?.lpacode || "";
                  const parts = fullCode.split("$");
                  const smdp = parts.length >= 2 ? parts[1] : "N/A";
                  const activation = parts.length >= 3 ? parts[2] : "N/A";

                  return (
                    <>
                      <div>
                        <span className="font-bold">SMDP:</span>
                        <span className="ml-4">{smdp}</span>
                      </div>
                      <div>
                        <span className="font-bold">Activation Code:</span>
                        <span className="ml-4">{activation}</span>
                      </div>
                    </>
                  );
                })()}
              </div>
              <div className="mb-4 p-4 w-full border-4 bg-slate-200 rounded-2xl">
                <h1 className="font-bold">For Andriod Devices: <span className="font-normal">Enter below Activation Code.</span> </h1>{" "}
                  {purchaseDetails?.lpacode || "N/A"}
              </div>









             <div className="mb-4 p-4 w-full border-4 bg-[#c5f1f1] rounded-2xl">
               <span className="font-bold">How to Install ?</span>
               <a href="https://www.airhubapp.com/info/Installation" target="_blank" rel="noopener noreferrer" className="ml-4 border-2 rounded-2xl hover:bg-blue-400 p-2 border-black ">Step by Step Guide</a>
             </div>
           </div>

           {/* Right column */}
           <div className="flex flex-col items-center justify-center ml-8">
            {/* <QRCode value={lpacode} className='border-4 p-2 border-[#47a192]' size={200} /> */}
              <QRCode value={purchaseDetails?.lpacode || "N/A"} className='border-4 p-2 border-[#47a192]' size={200} />


            <button
              className="text-[#595959] flex items-center border border-black px-4 py-2 rounded mt-4"
              onClick={() => handleDownload(lpacode)} 
              style={{ textDecoration: 'none' }}
            >
              <GoDownload size={30} /> Download
            </button>
          </div>


           {/* Close button */}
           <ImCross size={30} onClick={handleCross} className="cursor-pointer absolute top-2 right-2" />
           </div>
       </div>
        )}

         {/* RRA Price and Discount inputs with Buy Now button */}
      <div className="flex mt-12 items-center space-x-2">



      {/* {userRole === "Partner" &&(

<div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                             <label className="text-teal-900 block font-bold mb-1"> Website  Price </label>
             <p className=" py-6 px-6 rounded-lg w-36 text-center font-bold    text-[2rem]  " >
             {`$${parseFloat(sellingcost_airhub).toFixed(2)}`}
             </p>
        </div> 
        <div className="w-full md:w-1/2 px-3">
        <label className="text-teal-900 block mb-1 text-center   font-bold">Discount 
        </label> <p         className=" py-6 px-6 rounded-lg w-36 text-center font-bold    text-[2rem]  " > {`${discount}% `} </p>
        </div>
        </div>
      )} */}




      </div>

      {showConfirmModal && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
    <div className="bg-white p-8 rounded-md flex flex-col items-center relative w-96">
      <h3 className="text-xl font-bold mb-4">Are you sure you want to purchase this plan?</h3>
      <div className="flex justify-around w-full">
      <button
                className="px-6 py-2 rounded-lg bg-yellow-500 text-white"
                onClick={() => {
                  // When Confirm is clicked, start loading and trigger timeout for modal close
                  handleAddBundle();
                }}
              >
                Confirm
              </button>
        <button
          className="px-6 py-2 rounded-lg bg-gray-500 text-white"
          onClick={() => setShowConfirmModal(false)} // Close the modal on cancel
        >
          Cancel
        </button>
      </div>
      <ImCross size={20} onClick={() => setShowConfirmModal(false)} className="absolute top-2 right-2 cursor-pointer" />
    </div>
  </div>
)}

 {/* Show Loading Spinner */}
 {loading && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex items-center justify-center">
          <div className="spinner">
            <div className="loader"><LoadingSpinner/></div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default Plan;